import { motion } from "framer-motion";
import { MEDIA } from "@/data/company";
import { Truck, Package, Warehouse } from "@phosphor-icons/react";

const cards = [
  {
    title: "Heavy-Duty Trucks",
    detail:
      "Multi-axle trucks and trailers built for long-haul highway transport across India.",
    Icon: Truck,
    image: MEDIA.fleet,
  },
  {
    title: "Secured Payload",
    detail:
      "Tarpaulin-covered, ratchet-strapped loading with dedicated handlers for sensitive cargo.",
    Icon: Package,
    image: MEDIA.payload,
  },
  {
    title: "Warehousing Hub",
    detail:
      "Kanpur Transport Nagar warehousing for staging, cross-docking and short-term storage.",
    Icon: Warehouse,
    image: MEDIA.warehouse,
  },
];

export default function Fleet() {
  return (
    <section
      id="fleet"
      className="py-20 lg:py-32 bg-white"
      data-testid="fleet-section"
    >
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="flex flex-col md:flex-row md:items-end md:justify-between gap-6 mb-14">
          <div>
            <div className="flex items-center gap-3 mb-4">
              <span className="w-10 h-[2px] bg-[#EA580C]" />
              <span className="text-xs sm:text-sm font-bold uppercase tracking-[0.25em] text-slate-500">
                Fleet &amp; Infrastructure
              </span>
            </div>
            <h2 className="font-display font-black text-slate-900 text-4xl sm:text-5xl lg:text-6xl tracking-tighter leading-[0.95]">
              Built to haul.
              <br />
              <span className="text-slate-400">Ready to roll.</span>
            </h2>
          </div>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-3 gap-6 lg:gap-8">
          {cards.map((c, i) => (
            <motion.div
              key={c.title}
              initial={{ opacity: 0, y: 20 }}
              whileInView={{ opacity: 1, y: 0 }}
              viewport={{ once: true }}
              transition={{ duration: 0.5, delay: i * 0.08 }}
              data-testid={`fleet-card-${i}`}
              className="border-2 border-slate-900 bg-white overflow-hidden shadow-brutal hover-shadow-brutal transition-brutal"
            >
              <div className="relative h-56 overflow-hidden">
                <img
                  src={c.image}
                  alt={c.title}
                  className="w-full h-full object-cover"
                />
                <div className="absolute top-4 left-4 w-11 h-11 bg-[#EA580C] flex items-center justify-center">
                  <c.Icon size={22} weight="duotone" className="text-white" />
                </div>
              </div>
              <div className="p-6 border-t-2 border-slate-900">
                <h3 className="font-display font-black text-slate-900 text-xl tracking-tight">
                  {c.title}
                </h3>
                <p className="mt-2 text-slate-600 text-sm leading-relaxed font-medium">
                  {c.detail}
                </p>
              </div>
            </motion.div>
          ))}
        </div>
      </div>
    </section>
  );
}
